import { Component } from '@angular/core';


@Component({
  selector: 'app-banking-owner-information',
  templateUrl: './banking-owner-information.component.html',
  styleUrl: './banking-owner-information.component.css'
})
export class BankingOwnerInformationComponent {

}
